import React from 'react';
import styled from 'styled-components';
import { $switchCaseStrict } from 'dolla-switch';
import * as Bento from '@prezi/bento';
import * as Icons from '../../atoms/icons';
import { ColumnMinAutoMin, FlexColumn } from '../../atoms/dumb';
import { createDataLookup } from '../../const';
import { DisabledComponentWithTooltipWrapper } from './';
import { localI18n } from '../../../i18n';
const uxCopy = {
  title: localI18n._("Reusable"),
  desc: localI18n._("Anyone with access can make a copy and reuse this content.")
};
const GridColumn = styled(ColumnMinAutoMin).withConfig({
  displayName: "ToggleReusable__GridColumn",
  componentId: "ar6avo-0"
})(["column-gap:8px;padding-left:4px;"]);
const getTooltipUxCopy = reason => $switchCaseStrict(reason, {
  shared: () => ({
    title: localI18n._("Reusable restricted"),
    body: localI18n._("This was shared with you and it's not reusable")
  }),
  notAllowed: () => ({
    title: localI18n._("Reusable restricted"),
    body: localI18n._("It is not allowed to set reusable for this document.")
  })
});
const ToggleDisabled = ({
  checked,
  state
}) => state.reason ? React.createElement(DisabledComponentWithTooltipWrapper, {
  uxCopyTooltip: getTooltipUxCopy(state.reason)
}, React.createElement(Bento.Switch, {
  disabled: true,
  checked: checked,
  name: "document-reusable-toggle",
  id: "document-reusable-toggle",
  "data-lookup": createDataLookup('set-reusable-toggle')
})) : null;
const ToggleEnabled = ({
  checked,
  handleOnChange
}) => React.createElement(Bento.Switch, {
  checked: checked,
  name: "document-reusable-toggle",
  id: "document-reusable-toggle",
  onChange: ev => {
    handleOnChange(ev.currentTarget.checked);
  },
  onEnterKeyPress: () => {
    handleOnChange(!checked);
  },
  "data-lookup": createDataLookup('set-reusable-toggle')
});
const ToggleReusable = ({
  checked,
  state,
  handleOnChange
}) => React.createElement(GridColumn, null, React.createElement(Icons.Reuse, null), React.createElement(FlexColumn, null, React.createElement(Bento.Body2, null, uxCopy.title), React.createElement(Bento.Caption, null, uxCopy.desc)), state.disabled ? React.createElement(ToggleDisabled, {
  state: state,
  checked: checked
}) : React.createElement(ToggleEnabled, {
  checked: checked,
  handleOnChange: handleOnChange
}));
export default ToggleReusable;